export const CLEAR_NEW_PASSWORD_STATE = 'CLEAR_NEW_PASSWORD_STATE';

export const SEND_NEW_PASSWORD = 'SEND_NEW_PASSWORD';
export const SEND_NEW_PASSWORD_SUCCESS = 'SEND_NEW_PASSWORD_SUCCESS';
export const SEND_NEW_PASSWORD_ERROR = 'SEND_NEW_PASSWORD_ERROR';

export const CREATE_NEW_PASSWORD = 'CREATE_NEW_PASSWORD';
export const CREATE_NEW_PASSWORD_SUCCESS = 'CREATE_NEW_PASSWORD_SUCCESS';
export const CREATE_NEW_PASSWORD_ERROR = 'CREATE_NEW_PASSWORD_ERROR';
